import { IEmailTemplate } from "easy-email-editor";
import { MjmlToJson } from "easy-email-extensions";
import { BlockManager, BasicType, JsonToMjml } from "easy-email-core";
import {
  getHtmlTemplateById,
  updateHtmlTemplate,
} from "@api/email/htmlTemplate";
import { uploadBlogCoverImage } from "@api/blog/blog";

// Function to fetch template data
export const fetchTemplate = async (id: string): Promise<any> => {
  try {
    const response = await getHtmlTemplateById(id);
    const fetchedTemplate = response.data;

    const mjmlContent = fetchedTemplate?.content
      ? fetchedTemplate.content
      : BlockManager.getBlockByType(BasicType.PAGE)!.create({});
    const jsonContent = fetchedTemplate?.content
      ? MjmlToJson(mjmlContent)
      : mjmlContent;

    return {
      name: fetchedTemplate.name,
      subject: fetchedTemplate.subject || "What's new in Copilotly?",
      subTitle: fetchedTemplate.subTitle || "Check it out!",
      content: jsonContent,
    };
  } catch (error) {
    console.error("Error fetching template:", error);
    throw error;
  }
};

// Function to save template data
export const saveTemplate = async (
  id: string,
  values: IEmailTemplate,
  updatedName?: any
) => {
  try {
    const mjmlContent = JsonToMjml({
      data: values.content,
      mode: "production",
      context: values.content,
    });

    const saveData = {
      content: mjmlContent,
      name: updatedName,
      subject: values.subject,
      subTitle: values.subTitle,
    };

    await updateHtmlTemplate(id, saveData);
  } catch (error) {
    console.error("Error saving template:", error);
    throw error;
  }
};

// Function to upload image
export const uploadImage = async (data: File): Promise<string> => {
  try {
    const formData = new FormData();
    formData.append("image", data);

    const config = {
      headers: { "content-type": "multipart/form-data" },
    };

    const response = await uploadBlogCoverImage(formData, config);
    return response.data.url;
  } catch (error) {
    console.error("Error uploading image:", error);
    throw error;
  }
};
